<script>
import VDialog from 'vuetify/es5/components/VDialog'
export default {
  name: "YDialog",
  extends: VDialog,
  watch: {
    value (val) {
      this.$store.commit('ui/setDialogVisibility', val)
    }
  },
  mounted () {
    this.$store.commit('ui/setDialogVisibility', this.value)
  },
  beforeDestroy () {
    this.$store.commit('ui/setDialogVisibility', false)
  }
}
</script>